<template>
  <div :class="classProp" class="color-select">
    <label class="text-secondary mb-1 clickable" :class="{ 'font-weight-bold text-danger' : localShowUnselected && value === null || showUnselected && value === null}">{{ label }}</label>
    <div role="list" class="d-flex flex-wrap clickable" :class="{'pb-1 border-bottom border-danger': localShowUnselected && value === null || showUnselected && value === null}" tabindex=0>
      <div 
        role="button"
        tabindex=0
        v-for="(color, index) in items"
        :key="color"
        :style="`background-color: ${getColor(color)}; height:35px; width: 35px;`" 
        class="rounded-circle text-center text-white selected-cable-color mr-2 mr-md-1"
        :class="[
          disabledItems && disabledItems.indexOf(color)>= 0 ? 'opacity-25 cursor-not-allowed' : '', 
          !lightColors().includes(color) ? '': 'inner-shadow'
        ]"
        :title="`${displayItems[index]}${(disabledItems && disabledItems.indexOf(color)>= 0 ? ' - ' + $t('option-not-selectable') : '') }`" 
        @click.prevent="(disabledItems.indexOf(color) >= 0 ? '' : setSelection(color))"
        @keyup.enter="(disabledItems.indexOf(color) >= 0 ? '' : setSelection(color))"
        @keyup.space="(disabledItems.indexOf(color) >= 0 ? '' : setSelection(color))"
      >
        <span 
          :class="(lightColors().includes(value) ? 'text-dark': '')" 
          v-if="localValue === color" class="align-middle position-relative" 
          :style="`top: 6px;`"><i class="fas fa-check"></i></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ColorSelect',
  props: {
    items: Array,
    classProp: {
      type: String,
      default: 'w-50 pl-4 d-flex flex-column mb-2'
    },
    label: String,
    disabledItems: {
      type: Array,
      default: () => []
    },
    value: String,
    filterKey: {
      type: String,
      required: true
    },
    filterPropertyName: {
      type: String,
      required: true
    },
    showUnselected: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "update"
  },
  data () {
    return {
      ...mapState(['lightColors']),
      localValue: this.value,
      localShowUnselected: this.showUnselected,
      blockAutoFillAfterUnselect: false
    }
  },
  methods: {
    setSelection: function (color) {
      if (this.localValue === color) {
        this.localValue = null
        this.$emit("update", null)
        try {
          this.blockAutoFillAfterUnselect = true
          this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName })
        } catch (err) {
          this.$rollbar.error('Can not set filter to store', err)
        }
        return 
      }
      
      this.localValue = color
      this.$emit("update", color)
      try {
        this.blockAutoFillAfterUnselect = false
        this.$store.dispatch('setLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName, propertyValue: color })
      } catch (err) {
        this.$rollbar.error('Can not set filter to store', err)
      }

      if (this.value) this.localShowUnselected = false
    }
  },
  computed: {
    ...mapGetters({
      getColor: 'getCssColor' 
    }),
    displayItems () {
      return this.items.map(item => this.$t(`colorNames.${item}`))
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
      if (newValue) this.localShowUnselected = false
    },

    // autoFill
    disabledItems (newValue) {
      if (newValue.length + 1 === this.items.length) {
        if (!this.blockAutoFillAfterUnselect)
          this.$store.dispatch('trySetAutoFillValues', { scope: 'getters', filterKey: this.filterKey, propertyName: this.filterPropertyName })
      }

    },
    showUnselected (newValue) {
      this.localShowUnselected = newValue
    }
  }
}
</script>

<style>
.inner-shadow {
  box-shadow: rgba(169, 169, 169, .25) 0px 0px 1px 2px inset;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.pointer-events-none {
  pointer-events: none;
}

.opacity-25 {
  opacity: .25
}
.selected-cable-color:last-child {
  margin-right: 0 !important;
}
</style>